import {topMainVisualSlide} from '../component/slider/slider'

export default () => {
    if (document.querySelector('.index_page')) {
        topMainVisualSlide();
    };
}